import React, { Component } from "react"
import { connect } from "react-redux"
import styled, { injectGlobal, css } from 'styled-components'
import Link, { navigateTo} from "gatsby-link"
import { find, filter } from 'lodash'
import { rgba } from 'polished'
import moment from 'moment'

import { MetaTags } from '../components'

import { fetchSettings, getSettings, updateSettings } from '../store/settings'

import { warmBrown, coolBrown, grey } from '../styles/themes'
import { container, bgImage, button, bgIcon, innerContainer, hoverState, headerHeight } from '../styles/global'
import { heading2, paragraph, caption, heading, projectIntro } from '../styles/type'
import { media } from '../styles/utils'
import { pageBackground } from '../styles/colors'

class Journal extends Component {

	state = {
        data : [],
        activeCategory: 'all'
	}
		
	componentWillMount = () => {
        const { updateSettings, fetchSettings } = this.props;
        fetchSettings()

		this.setState({
            data: this.props.data.wordpressJournal,
            activeCategory: this.props.pathContext.section || 'all'
        })
        
        updateSettings({
            theme: {
                text: '#595850',
                background: pageBackground,
            }
        })
    }

    renderCatNav = () => {
        const { data, activeCategory } = this.state;

        if (data.cats) {
            const cats = data.cats.map((cat, i) => {
                return (
                    <CatLink
                        key={i}
                        to={`/journal/section/${cat.slug}`}
                        selected={activeCategory == cat.slug}
                    >
                        {cat.title}
                    </CatLink>
                )
            })  

            return (
                <CatNav>
                    <Heading>Filter:&nbsp;</Heading>
                    <CatLink 
                        to={`/journal`}
                        selected={activeCategory == 'all'}
                    >
                        All
                    </CatLink>
                    {cats}
                </CatNav>
            )
        }
    }

    getArticles = () => {
		const { data, activeCategory} = this.state;

		if (!data.articles) return;

		if (activeCategory !== 'all') {
			return filter(data.articles, { catSlug: activeCategory })
		} else {
			return data.articles
		}
    }
    
    renderArticles = () => {
        const { data, activeCategory } = this.state;
        const articles = this.getArticles()

        if (articles) {
            const items = articles.map((article, i) => {
                const acf = JSON.parse(article.acf_json);

                let isLarge = acf.is_featured_format;
                if (isLarge === undefined) isLarge = false;
                // if(i % 6 == 0) isLarge = true; //every 6th is large format

                return (
                    <div
                        className={`article ${isLarge ? 'large' : 'medium'}`}
                        key={i}
                        onClick={() => navigateTo(`/journal/${article.slug}`)}
                    >

                        <ListImageLink
                            image={acf.hero_image_listing.sizes.large}
                            to={`/journal/${article.slug}`}
                        />

                        <Info>
                            <TitleLink
                                to={`/journal/${article.slug}`}
                            >
                                {article.title}
                            </TitleLink>

                            <Meta>
                                <Category>{article.catTitle}</Category>
                            </Meta>

                            {isLarge && acf.listing_description &&(
                                <Description
                                    dangerouslySetInnerHTML={{__html: acf.listing_description }}  
                                />
                            )}
                        </Info>

                    </div>
                )
            })   

            return (
                <Articles>
                    <Container>
                        {items}
                    </Container>
                </Articles>
            )
        }
    }

  	render() {
        const splashActive = this.props.settings.splashActive;
        const { data } = this.state;

        let firstPostACF;

        if (data.articles) {
            firstPostACF = JSON.parse(data.articles[0].acf_json);           
        }

		return (
			<Wrapper
                active={splashActive == false}
            >

                {data && (
                    <MetaTags 
                        title={`Paul Conrad Architects — Journal`}
                        description={firstPostACF.meta_description}
                        url={`https://www.conradarchitects.com/journal`}
                        image={firstPostACF.hero_image.sizes.medium2}
                    />
                )}

                {this.renderArticles()}
                {this.renderCatNav()}

			</Wrapper>
		)	
  	}
}

const Wrapper = styled.div`
	display: flex;
    flex-direction: row;
	width: 100%;
	z-index: 2;
    box-sizing: border-box;
    transition: all 0.75s ease;
	transition-delay: 0.4s;
	will-change: transform;
    transform: translateY(100px);
	opacity: 0;
    /* Single source of truth for the gap below the header, matching
       Projects.js — previously this was zeroed at tablet and re-added on
       Articles, which collapsed the spacing. */
    padding-top: 10rem;

    ${media.tablet`
        flex-direction: column;
        align-items: center;
        padding-left: 0;
        padding-right: 0;
        padding-bottom: 0;
    `}

    ${media.phone`
        padding-top: 0;
    `}

	${props => {
		if (props.active) return css`
			transform: translateY(0);
			opacity: 1;
		`
	}}
`


// category navigation
const Heading = styled.div``
const CatLink = styled(Link)`
    ${props => {
        if (props.selected) return css`
            opacity: 1!important;
        `
    }}
`
const CatNav = styled.div`
    order: -1;
    align-self: flex-start;
    position: sticky;
    top: calc(${headerHeight.desktop}px + 10rem);
    display: flex;
    flex-direction: column;
    width: 180px;

    ${media.laptop`
        top: calc(${headerHeight.laptop}px + 10rem);
    `}

    ${media.tablet`
        order: 1;
        align-self: initial;
        top: initial;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        box-sizing: border-box;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 70px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        background: ${pageBackground};
    `}

    ${media.phone`
        justify-content: flex-start;
        align-items: initial;
        overflow-x: auto;
        overflow-y: hidden;
        height: auto;
        padding: 20px 0;
        padding-bottom: calc(20px + env(safe-area-inset-bottom));
    `}

    ${Heading}, ${CatLink} {
        ${caption};
        text-indent: 0!important;
        margin-bottom: 1rem;
        opacity: 0.5;

        /* &:not(:nth-child(2)) {
            opacity: 0.5;
        } */

        ${media.laptop`
            font-size: 12px;
            line-height: 12px;
        `}

        ${media.tablet`
            &:not(:first-child) {
                margin-left: 5rem;
            }
        `}

        ${media.phone`
            &:first-child {
                margin-left: auto;
                padding-left: 40px;
            }
            &:last-child {
                margin-right: auto;
                padding-right: 40px;
            }
        `}
    }

    ${CatLink} {
        
    }

    /* mobile only filter heading */
    ${Heading} {
        display: none;

        ${media.tablet`
            display: flex;
        `}
    }
`


// articles listing
const Container = styled.div``
const Articles = styled.div`
    min-height: 100vh;
    ${innerContainer};
    margin-left: auto;
    margin-right: auto;

    /* Top spacing lives on Wrapper (see above) so it stays in step with
       Projects at every breakpoint. */
    ${media.tablet`
        transform: none;
        padding-bottom: 5rem;
        min-height: calc(100vh - 150px);
    `}

    ${media.phone`
        margin: 0;
        min-height: calc(100vh - 160px);
	`}

    ${Container} {
        display: flex;
        flex-flow: row wrap;
        margin-left: -2.5rem;
        margin-right: -2.5rem;

        ${media.phone`
            margin: 0;
            flex-direction: column;
        `}
    }
`

const ListImageLink = styled(Link)`
	background-image: url(${props => props.image});
	${bgImage}
`


// article type styles

const TitleLink = styled(Link)`
    display: block;
    ${projectIntro};
    ${hoverState};

    /* Clamp to 2 lines so cards line up regardless of title length */
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
`
const Category = styled.div``
const Date = styled.div``
const Description = styled.div``
const Meta = styled.div`
	display: flex;
    margin-top: 1rem;

    > *:nth-child(2) {
        margin-left: 3px;
    }
`

const Info = styled.div`
    /* White so each card reads as one continuous panel with the white logo
       band at the top of the listing artwork. */
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;

    ${Category}, ${Date}, ${Description} {
        &, * {
            font-family: 'Scto';
            font-size: 14px;
            line-height: 16px;
            color: #999999;

            ${media.laptop`
                font-size: 10.5px;
                line-height: 12px;
            `}
        }
    }

    ${Description} {
        margin-top: auto;

        ${media.phone`
            display: none;
        `}
    }
`

injectGlobal`
    .article {
        display: flex;
        margin-bottom: 5rem;
        padding-left: 2.5rem;
        padding-right: 2.5rem;
        box-sizing: border-box;

        &:hover {
            cursor: pointer;
        }

        /* Listing artwork is a composite: a white band with the publication's
           logo left-aligned, above the photograph. 108 of 109 sources are
           1200x800, so cover crops nothing meaningful and — unlike contain —
           keeps the logo at a constant position across every card. The lone
           portrait source letterboxed under contain, which is what made its
           logo look shifted. */
        &.medium,
        &.large {
            flex-direction: column;

            ${ListImageLink} {
                width: 100%;
                height: 0;
                background-color: ${pageBackground};
                background-size: cover;
                background-position: center center;
            }

            ${Info} {
                padding: 3rem;
                min-height: 110px;
                box-sizing: border-box;
            }
        }

        /* Half-width cards, 3:2 to match the source artwork. */
        &.medium {
            flex: 0 1 50%;

            ${ListImageLink} {
                padding-bottom: 66.67%;
            }
        }

        /* Featured articles (is_featured_format in WP) run full width as a
           two-column card: artwork on the left, title on the right. The info
           panel is white so it reads as one continuous card with the white
           logo band along the top of the artwork. */
        &.large {
            flex: 0 1 100%;
            flex-direction: row;
            align-items: stretch;

            ${ListImageLink} {
                flex: 0 0 48%;
                width: auto;
                /* 48% column at the artwork's native 3:2 → 48 * (2/3) = 32%.
                   Percentage padding resolves against the card width, so this
                   keeps the source uncropped. */
                padding-bottom: 32%;
            }

            ${Info} {
                flex: 1 1 52%;
                background-color: #FFFFFF;
                justify-content: flex-start;
                padding: 5rem;

                ${media.laptop`
                    padding: 4rem;
                `}
            }

            ${TitleLink} {
                font-size: 30px;
                line-height: 38px;
                /* Roomier than the 2-line clamp the half-width cards use. */
                -webkit-line-clamp: 4;

                ${media.laptop`
                    font-size: 23px;
                    line-height: 29px;
                `}
            }

            /* Stack below desktop — the two columns get too narrow to read. */
            ${media.tablet`
                flex-direction: column;

                ${ListImageLink} {
                    flex: none;
                    width: 100%;
                    padding-bottom: 66.67%;
                }

                ${Info} {
                    flex: none;
                    padding: 3rem;
                }

                ${TitleLink} {
                    font-size: 22px;
                    line-height: 26px;
                }
            `}
        }


        /* mobile: full-width stacked cards, still with a uniform image ratio */
        ${media.phone`
            flex: none !important;
            flex-direction: column;
            padding-left: 0;
            padding-right: 0;

            ${ListImageLink} {
                height: 0 !important;
                padding-bottom: 66% !important;
            }

            ${Info} {
                padding: 2rem 3rem 3rem;
                min-height: 90px;
            }
        `}
    }
`


const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Journal);


export const pageQuery = graphql`
	query Journal {
		wordpressJournal {
            articles {
                ... on articles_4 {
                    title
                    slug
                    publishedDate
                    acf_json
                }
            }
		}
	}
`



// WEBPACK FOOTER //
// ./src/pages/Journal.js